import axios from "axios";


const langeId = localStorage.getItem("LangId") || 1;
// localStorage.setItem("serverPath","10.10.150.48:8000") ;

axios.defaults.baseURL = "https://admin.dabs.af/api/";
// axios.defaults.baseURL = "http://localhost:8085/dab/api/";


// const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
// axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;



const request = {

  get: async (url) => await axios.get(url).then((response) => response.data),
  post: async (url) => await axios.post(url).then((response) => response.data),
};

// const request = {
//   get: async (url) => await axios.get(url).then((response) => response.data),

//   post: async (url, data) => {
//     try {
//       const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
//       const response = await axios.post(url, data, {
//         headers: {
//           'X-CSRF-TOKEN': csrfToken,
//           // Add any other headers you need here
//         },
//       });
//       return response.data;
//     } catch (error) {
//       console.error(error);
//       throw error; // Rethrow the error to handle it further if needed
//     }
//   },
// };




const Menu = {
  get: () => request.get(`menu/${langeId}`),
};



const Language = {
  get: () =>
    request.get("lang"),
};








const News = {
  get: (pageNumber) => request.get(`listnews/${langeId}?page=${pageNumber}`),
  getTopNews: () => request.get(`listnewstop3/${langeId}`),
  getById: (id) => request.get(`news/${id}`),
  getByCategory: (id) => request.get(`newscatagory/${id}/${langeId}`),
  getByTag: (id) => request.get(`news_by_tag/${id}/${langeId}`),
  searchByTitle: (title) => request.get(`news_title/${title}/${langeId}`),
  postComment: (comment, user_name, email, news_id) => request.post(`news_comments?comment=${comment}&name=${user_name}&email=${email}&news_id=${news_id}`),
  getComments: (id) => request.get(`news_comment_by_news_id/${id}`),
  postHitCount: (news_id) => request.post(`updateHitCount?id=${news_id}`),
  getNewsCountById: (id) => request.get(`news_counts/${id}`),
};

const Category = {
  get: () => request.get("catagory"),
};

const Tags = {
  get: () => request.get("tags"),
};

const Message = {
  get: () => request.get(`ceomessage/${langeId}`),
};

const Slider = {
  get: () => request.get(`slider/${langeId}`),
};

const Project = {
  get: (pageNumber) => request.get(`listprojects/${langeId}?page=${pageNumber}`),
  getTopProjects: () => request.get(`projectstop3/${langeId}`),
  getById: (id) => request.get(`projects/${id}`),
};

const ContactDir = {
  get: (pageNumber) => request.get(`contact_directory?page=${pageNumber}`),
  // getById: (id) => request.get(`projects/${id}`),
};

const Complaint = {
  get: () => request.get(`complaint_type/${langeId}`),
  // addComplaint: (formData) => request.post(`add_complaint`, formData),
  addComplaint: (name, bill_number, phone_number, comments, specific_address, email, complaint_type_id) => request.post(`add_complaint?name=${name}&bill_number=${bill_number}&phone_number=${phone_number}&comments=${comments}&specific_address=${specific_address}&email=${email}&complaint_type_id=${complaint_type_id}`),
};


// const Vendor = {
//   // Add your vendor-related API functions here
//   addVendor: (name,contactPersonName,contactPersonMobile,email,attachment,jawazNo,jawazExpiryDate,password,TenderID) => request.post(`addVendor?Name=${name}&ContactPersonName=${contactPersonName}&ContactPersonMobile=${contactPersonMobile}&Email=${email}&Attachment=${attachment.name}&JawazNo=${jawazNo}&JawazExpiryDate=${jawazExpiryDate}&Password=${password}&TenderID=${TenderID}`,{
//     headers: {
//       'Content-Type': 'multipart/form-data',  // Set content type to multipart/form-data
//     },
//   }),
// };


// const Vendor = {
//   addVendor: (name, contactPersonName, contactPersonMobile, email, attachment, jawazNo, jawazExpiryDate, password, TenderID) => {
//     const requestBody = {
//       Name: name,
//       ContactPersonName: contactPersonName,
//       ContactPersonMobile: contactPersonMobile,
//       Email: email,
//       Attachment: attachment, // assuming attachment is a File object
//       JawazNo: jawazNo,
//       JawazExpiryDate: jawazExpiryDate,
//       Password: password,
//       TenderID: TenderID,
//     };

//     return request.post('addVendor', requestBody);
//   },
// };


const Vendor = {
  // Add your vendor-related API functions here
  addVendor: async (Name, ContactPersonName, ContactPersonMobile, Email, Attachment, JawazNo, JawazExpiryDate, Password, TenderID) => {
    // const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    console.log(Name, ContactPersonName, ContactPersonMobile, Email, Attachment, JawazNo, JawazExpiryDate, Password, TenderID);

    const formData = new FormData();
    formData.append('Name', Name);
    formData.append('ContactPersonName', ContactPersonName);
    formData.append('ContactPersonMobile', ContactPersonMobile);
    formData.append('Email', Email);
    formData.append('Attachment', Attachment); // Assuming 'attachment' is a File object
    formData.append('JawazNo', JawazNo);
    formData.append('JawazExpiryDate', JawazExpiryDate);
    formData.append('Password', Password);
    formData.append('TenderID', TenderID);

    console.log(formData);

    return request.post('addVendor', formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data

      },
    });

    // return response;
  },
};




// const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

// const Vendor = {
//   // Add your vendor-related API functions here
//   addVendor: (name,contactPersonName,contactPersonMobile,email,attachment,jawazNo,jawazExpiryDate,password,TenderID) => request.post(`addVendor?name=${name}&contactPersonName=${contactPersonName}&contactPersonMobile=${contactPersonMobile}&email=${email}&attachment=${attachment}&jawazNo=${jawazNo}&jawazExpiryDate=${jawazExpiryDate}&password=${password}&TenderID=${TenderID}`, {
//     headers: {
//       'X-CSRF-TOKEN': csrfToken,
//     },
//   })
// };


const CustomerForms = {
  get: (pageNumber) => request.get(`listforms/${langeId}?page=${pageNumber}`),
};

const Dam = {
  get: (pageNumber) => request.get(`listdams/${langeId}?page=${pageNumber}`),
  getTopProjects: () => request.get(`damstop3/${langeId}`),
  getById: (id) => request.get(`dams/${id}`),
};
const Messages = {
  getTopMessages: () => request.get(`smallMessage/${langeId}`),
};

const last_statistics = {
  get: () => request.get(`last-statistics`),
};


const Jobs = {
  get: (pageNumber) => request.get(`listjobs?page=${pageNumber}`),
  getTopJobs: () => request.get(`jobtop3`),
  getById: (id) => request.get(`jobs/${id}`),
};

const Tenders = {
  get: (pageNumber) => request.get(`listtenders?page=${pageNumber}`),
  getArchive: (pageNumber) => request.get(`list_tender_archive?page=${pageNumber}`),
  getTopTenders: () => request.get(`tendertop3`),
  getById: (id) => request.get(`tenders/${id}`),
  search: (query) => request.get(`search_tender?query=${query}`),
  searchArchive: (query) => request.get(`search_tender_archive?query=${query}`),
};

const Testimonial = {
  // get: (pageNumber) => request.get(`listjobs/?page=${pageNumber}`),
  getTopTestimonial: () => request.get(`testimonialtop3/${langeId}`),
};

const Biography = {
  get: () => request.get(`biography/${langeId}`),
  getTopTestimonial: () => request.get(`testimonialtop3/${langeId}`),
  getOurTeam: () => request.get(`ourteam/${langeId}`),
};

const Magazine = {
  get: (pageNumber) => request.get(`listmagazines/${langeId}?page=${pageNumber}`),
  getTopMagazine: () => request.get(`magazinetop4`),
};

const Gallery = {
  get: (pageNumber) => request.get(`listgallery/${langeId}?page=${pageNumber}`),
  getArticle: (pageNumber) => request.get(`listArticles?page=${pageNumber}`),
  getById: (id) => request.get(`gallery/${id}`),
};

const Page = {
  getById: (pageId) => request.get(`page/${pageId}/${langeId}`),
};

const Video = {
  get: (pageNumber) => request.get(`listvideo?page=${pageNumber}`),
};

const Awards = {
  get: (pageNumber) => request.get(`listaward?page=${pageNumber}`),
  getById: (id) => request.get(`award/${id}`),
};

const Reports = {
  get: (pageNumber) => request.get(`listreports?page=${pageNumber}`),
  getById: (id) => request.get(`reports/${id}`),
};

const ReportTypes = {
  get: (type, pageNumber) => request.get(`report_type/${type}?page=${pageNumber}`),

};
const investmentTypes = {
  get: (type, pageNumber) => request.get(`investment/${type}?page=${pageNumber}`),
};

const investment = {
  getById: (id) => request.get(`investments/${id}`),
};

const SmallPurchases = {
  get: (pageNumber) => request.get(`small_purchase?page=${pageNumber}`),
  getArchive: (pageNumber) => request.get(`archive_small_purchase?page=${pageNumber}`),
};

const LeaveMessage = {
  postMessage: (user_name, email, message) => request.post(`add_contact?name=${user_name}&email=${email}&message=${message}`),
};

const Law = {
  get: (pageNumber) => request.get(`reportlist_type_law?page=${pageNumber}`),
  getById: (id) => request.get(`reports/${id}`),
};

const Policies = {
  get: (pageNumber) => request.get(`reportlist_type_policy?page=${pageNumber}`),
  getById: (id) => request.get(`reports/${id}`),
};


const Search = {
  // const response = await axios.get(`/api/search?q=${searchQuery}`);
  get: async (searchQuery, pageNumber) => await request.get(`search?q=${searchQuery}&page=${pageNumber}`),
};
const dabsStatus = {
  get: () => request.get(`report_dabsstatus`),
};
const VendorInfo = {
  addVendorInformation: (formData) =>
    request.post("add_vendorinfo", formData),
};


export {
  VendorInfo,
  dabsStatus,
  Menu,
  last_statistics,
  Language,
  News,
  Category,
  Messages,
  Tags,
  Message,
  Slider,
  Project,
  Dam,
  Jobs,
  Tenders,
  Testimonial,
  Biography,
  Magazine,
  Gallery,
  Page,
  Video,
  Awards,
  Reports,
  ReportTypes,
  investment,
  investmentTypes,
  SmallPurchases,
  LeaveMessage,
  Law,
  Policies,
  ContactDir,
  Complaint,
  CustomerForms,
  Search,
  Vendor,

};
